<template>
  <div class="comparativeDetails">
    <div class="header">
      <div class="title">
        {{ satementData.reconciliationName }}
      </div>
    </div>
    <div class="content">
      <Tabs v-model="tabs" @on-click="changeTab">
        <TabPane :label="item.tabName + '（' + item.num + '）'" :name="item.tabName" v-for="(item, index) in tabData"
          :key="index"></TabPane>
      </Tabs>
      <div class="firstTable" v-if="summaryData.length > 0">
        <div class="tableHead">
          <div class="headItem"></div>
          <div class="headItem">记录数合计</div>
          <div class="headItem">保费合计</div>
          <div class="headItem">费用合计</div>
          <div v-if="satementData.reconciliationType == 1" class="headItem">首期基础费用合计</div>
          <div v-if="satementData.reconciliationType == 1" class="headItem">首期限时加费合计</div>
          <div v-if="satementData.reconciliationType == 4" class="headItem">续期基础费用合计</div>
          <div v-if="satementData.reconciliationType == 4" class="headItem">续年服务津贴合计</div>
        </div>
        <div class="tableRow" v-for="(item, index) in summaryData" :key="index">
          <div class="header">{{ item.type }}</div>
          <div class="rowItem">{{ item.totalNumber || '0' }}</div>
          <div class="rowItem">{{ item.totalFee || '0' }}</div>
          <div class="rowItem" :class="{'orange':item.isCompulsory == 1 && item.isOk == 1,'red':item.isOk == 2}">{{ item.totalCommission || '0' }}</div>
          <div class="rowItem" :class="{'orange':item.isCompulsory == 1 && item.isOk == 1,'red':item.isOk == 2}" v-if="satementData.reconciliationType == 1">{{ item.totalBaseCommission || '0' }}</div>
          <div class="rowItem" :class="{'orange':item.isCompulsory == 1 && item.isOk == 1,'red':item.isOk == 2}" v-if="satementData.reconciliationType == 1">{{ item.totalActCommission || '0' }}</div>
          <div class="rowItem" :class="{'orange':item.isCompulsory == 1 && item.isOk == 1,'red':item.isOk == 2}" v-if="satementData.reconciliationType == 4">{{ item.totalRenewBaseCommission || '0' }}
          </div>
          <div class="rowItem" :class="{'orange':item.isCompulsory == 1 && item.isOk == 1,'red':item.isOk == 2}" v-if="satementData.reconciliationType == 4">{{ item.totalRenewAllowance || '0' }}</div>
        </div>
      </div>
      <div class="search-tools">
        <div class="search-box btn3">
          <div class="input-item">
            <span class="label">保单号</span>
            <Input v-model="searchParams.policyNo" placeholder="请输入" clearable />
          </div>
          <Button type="primary" @click="getList()">搜索</Button>
        </div>
      </div>
      <Table :columns="columns" :data="tableData" id="table1">
        <template slot-scope="{ row, index }" slot="action">
          <div class="detail">
            <span v-if="row.isCompulsory == '1'">已强平</span>
          </div>
        </template>
      </Table>
      <div class="pageBox">
        <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="pageChange"
          style="text-align: center" />
      </div>
    </div>
    <div class="footer">
      <Button type="primary" ghost @click="back(backUrl)">返回</Button>
      <Button type="primary" ghost @click="detailPage(1)">开票</Button>
      <Button type="primary" ghost @click="detailPage(2)">回款</Button>  
      <Button type="primary" ghost @click="reStatement">重新对账</Button>
      <Button type="primary" ghost @click="daochu()">导出系统数据</Button>
    </div>
  </div>
</template>

<script>
import { pageTool,common } from "@/api/mixins";
export default {
  props: ['checkId'],
  mixins: [ pageTool,common],
  data() {
    return {
      searchParams: {},
      satementData:{},
      tabs: '汇总',
      allRight: "",
      backUrl: '', //返回链接
      summaryData: [],
      tabData: {},
      columns: [
        {
          title: '保单号',
          key: 'policyNo',
          align: 'center',
          width: "180",
          fixed: "left",
        },
        {
          title: "保单年度",
          align: "center",
          key: "commissionIndex",
          minWidth: 120,
          tooltip: true,
        },
        {
          title: '交费期次',
          key: 'commissionPeriods',
          align: 'center',
          width: "100",
        },
        {
          title: '保险产品',
          key: 'productName',
          align: 'center',
          width: "200",
        },
        {
          title: '险种名称',
          key: 'productTypeName',
          align: 'center',
          width: "200",
        },
        {
          title: '保单状态',
          key: 'policyStatus',
          align: 'center',
          width: "100",
        },
        {
          title: '承保日期',
          key: 'insureTime',
          align: 'center',
          width: "200",
        },
        {
          title: '生效日期',
          key: 'effectTime',
          align: 'center',
          width: "200",
        },
        {
          title: '实收日期',
          key: 'actualReceiveTime',
          align: 'center',
          width: "200",
        },
        {
          title: '保障期',
          key: 'guaranteeValueDesc',
          align: 'center',
          width: "100",
        },
        {
          title: '交费期',
          key: 'payValueDesc',
          width: "140",
          align: 'center',
        },
        {
          title: "费用类型",
          align: "center",
          minWidth: 140,
          tooltip: true,
          render(h, params) {
            const commissionType = params.row.commissionType;
            if ((commissionType == 1||commissionType == 3)&&params.row.commissionIndex > 1){
              return <span>续期基础费用</span>;
            } else if (commissionType == 1||commissionType == 3) {
              return <span>基础费用</span>;
            } else if (commissionType == 2||commissionType == 4||commissionType == 11||commissionType == 12) {
              return <span>限时加费活动
                <Tooltip
                trigger="hover"
                content="content"
                transfer={true}
              >
                <span class="tip-icon">?</span>
                <div slot="content">
                  <div>{ params.row.activityName }</div>
                  <span>{ '(' +  params.row.activityBegin+ '至'+ params.row.activityEnd+ ')' }</span>
                </div>
              </Tooltip>
              </span>;
            } else if (commissionType == 5) {
              return <span>后置费用</span>;
            }else if(commissionType == 13||commissionType == 14){
              return <span>梯度加费
                <Tooltip
                trigger="hover"
                content="content"
                transfer={true}
              >
                <span class="tip-icon">?</span>
                <div slot="content">
                  <div>{ params.row.activityName }</div>
                  <span>{ '(' +  params.row.activityBegin+ '至'+ params.row.activityEnd+ ')' }</span>
                </div>
              </Tooltip>
              </span>;
            }else if(commissionType == 15||commissionType == 16){
              return <span>续年服务津贴</span>;
            }else if(commissionType == 17||commissionType == 18){
              return <span>继续率费用</span>;
            }
          },
        },
        {
          title: '保费',
          align: 'center',
          children: [
            {
              title: '系统保费',
              key: 'fee',
              width: "120",
              align: 'center',
            },
            {
              title: '供应商保费',
              key: 'supplierFee',
              width: "120",
              align: 'center',
            },
          ]
        },
        {
          title: '费率',
          align: 'center',
          children: [
            {
              title: '系统费率',
              key: 'commission',
              align: 'center',
              width: "120",
              render(h, params) {
                const commission = params.row.commission;
                if(Number(commission)){
                  return <span>{commission}</span>; 
                }else{
                  return <span>-</span>
                }
              },
            },
            {
              title: '供应商费率',
              key: 'supplierCommission',
              align: 'center',
              width: "120",
              render(h, params) {
                const supplierCommission = params.row.supplierCommission;
                if(Number(supplierCommission)){
                  return <span>{supplierCommission}</span>; 
                }else{
                  return <span>-</span>
                }
              },
            },
          ]
        },
        {
          title: '费用',
          align: 'center',
          children: [
            {
              title: '系统费用',
              key: 'commissionPrice',
              align: 'center',
              width: "120",
            },
            {
              title: '供应商费用',
              key: 'supplierCommissionPrice',
              align: 'center',
              width: "120",
            },
          ]
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          width: "230",
        },
      ]
    }
  },
  mounted() {
    this.backUrl = this.$route.query.backUrl;
    this.detail()
    this.initListAjax('/buz/molCommissionConsult/detailsPageByCheckId')
  },
  methods: {
    daochu() {
      if(this.$units.pointAction('offline_8_1_5')){
        this.loading = true;
        this.$http({
          url: "/buz/molCommissionConsult/detailsExportByCheckId",
          type: "POST",
          responseType: "blob",
          data: {
            checkId: this.$route.query.id || this.checkId,
            tabs:this.tabs,
            ...this.searchParams
          },
        })
          .then((res) => {
            this.loading = false;
            this.$units.daochu(res);
          })
          .catch((e) => {
            this.loading = false;
          });
        }else{
        this.$Message.error('无权操作，请联系您的上级')
      }
    },
    getColumns() {
      if (this.satementData.reconciliationType == 1 || this.satementData.reconciliationType == 2) {
        let idx = ''
        idx = this.columns.findIndex(item => item.key == 'commissionIndex')
        this.columns.splice(idx, 1);
        idx = this.columns.findIndex(item => item.key == 'actualReceiveTime')
        this.columns.splice(idx, 1);
      }
      window.setTimeout(()=>{
        document.getElementById("table1").querySelectorAll(".ivu-table-body")[0].scrollLeft = document.getElementById("table1").querySelectorAll(".ivu-table-body")[0].scrollWidth 
      },300)
    },
    detailPage(height=0){
      this.$router.push({
        path:"/offline/reconciliationAccounts/detail",
        query:{
          id:this.$route.query.id || this.checkId,
          height:height
        }
      })
    },
    // 重新对账
    reStatement() {
      if(this.$units.pointAction('offline_8_1_2')){
        this.$notice.inquiry("是否重置全部流程重新开始对账？").then(async () => {
          this.$http({
            url: '/buz/commissionReconciliation/jumpBack',
            type: 'POST',
            data: {
              id: this.$route.query.id || this.checkId
            },
          }).then((res) => {
            if(res.data.step == '1'){
              this.$emit('backStep')
            }
          })
        }).catch((res) => {
          console.log(res);
        });
      }else{
        this.$Message.error('无权操作，请联系您的上级')
      }
    },
    changeTab() {
      this.getSummaryData()
      this.getList()
    },
    getTabs() {
      this.$http({
        url: '/buz/molCommissionConsult/queryTabsInfo',
        type: 'POST',
        data: {
          checkId: this.$route.query.id || this.checkId,
        },
      }).then((res) => {
        if (res.data) {
          this.tabData = res.data
          this.tabs = this.tabData[0].tabName
        }
      })
    },
    listCallback(res) {
      // isOk，对比状态（0待对比；1一致，2费用不一致，3供应商没有的记录，4系统未生成费用，5系统无此保单）
      // isCompulsory，是否强平（0否，1是）
      res.data.forEach(item => {
        
          if (item.isCompulsory == 1) {
            item.cellClassName = {
              commission: 'demo-table-cell-name2',
              supplierCommission: 'demo-table-cell-name2',
              commissionPrice: 'demo-table-cell-name2',
              supplierCommissionPrice: 'demo-table-cell-name2',
            }
          } 
          if (item.isOk == 2) {
            item.cellClassName = {
              commission: 'demo-table-cell-name1',
              supplierCommission: 'demo-table-cell-name1',
              commissionPrice: 'demo-table-cell-name1',
              supplierCommissionPrice: 'demo-table-cell-name1',
            } 
        }
      });
    },
    setListParams(params) {
      params.checkId = this.$route.query.id || this.checkId;
      params.tabs = this.tabs;
    },
    //获取汇总数据
    getSummaryData() {
      this.$http({
        url: '/buz/molCommissionConsult/summaryTabs',
        type: 'POST',
        data: {
          checkId: this.$route.query.id || this.checkId,
          tabs: this.tabs,
        },
      }).then((res) => {
        if (res.data) {
          this.summaryData = res.data
        }
      })
    },
    detail() {
      this.$http({
        url: "/buz/commissionReconciliation/read/detail",
        type: "GET",
        data: { id: this.$route.query.id || this.checkId },
      }).then((res) => {
        this.satementData = res.data
        this.getSummaryData()
        this.getTabs()
        this.getColumns()
      });
    },
    // 分页
    pageChange(pageNo) {
      this.pageNo = pageNo;
      this.getList(pageNo)
    },
  }
}
</script>

<style lang="scss" scoped>
@import "./reconciliationCompleted.scss";
</style>